import React, { useEffect, useRef, useState } from 'react'
import styles from './Toast.module.css'

const ToastItem = ({ toast, onRemove }) => {
  const [isExiting, setIsExiting] = useState(false)
  const timeoutRef = useRef(null)
  const progressRef = useRef(null)

  useEffect(() => {
    if (toast.duration && toast.duration > 0) {
      timeoutRef.current = setTimeout(() => {
        handleClose()
      }, toast.duration)

      // Animar la barra de progreso
      if (progressRef.current) {
        progressRef.current.style.animationDuration = `${toast.duration}ms`
      }
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [toast.duration])

  const handleClose = () => {
    setIsExiting(true)
    setTimeout(() => {
      onRemove(toast.id)
    }, 300) // Tiempo de animación de salida
  }

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✓'
      case 'error':
        return '✕'
      case 'warning':
        return '⚠'
      case 'info':
        return 'ℹ'
      default:
        return 'ℹ'
    }
  }

  const toastClass = `${styles.toast} ${styles[toast.type]} ${isExiting ? styles.toastExit : ''}`

  return (
    <div className={toastClass}>
      <div className={styles.icon}>{getIcon()}</div>
      <div className={styles.content}>{toast.message}</div>
      <button
        className={styles.closeButton}
        onClick={handleClose}
        aria-label="Cerrar notificación"
      >
        ✕
      </button>
      {toast.duration && toast.duration > 0 && (
        <div
          ref={progressRef}
          className={styles.progressBar}
          style={{ backgroundColor: 'currentColor' }}
        />
      )}
    </div>
  )
}

const Toast = () => {
  const [toasts, setToasts] = useState([])

  useEffect(() => {
    const handleToast = (event) => {
      const { type, message, duration } = event.detail
      const id = Date.now() + Math.random()
      setToasts((prev) => [...prev, { id, type, message, duration: duration || 5000 }])
    }

    document.addEventListener('show-toast', handleToast)

    return () => {
      document.removeEventListener('show-toast', handleToast)
    }
  }, [])

  const handleRemove = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }

  if (toasts.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={handleRemove} />
      ))}
    </div>
  )
}

export default Toast

